/**
 * Sentinel option value meaning "entity has no value for this field" — used by
 * "No department" / "No role" / "No value" style filter options that translate
 * to an IS NULL match on the backend. Deliberately unlikely to collide with a
 * real entity id or a user-defined custom-attribute option value.
 */
export const FILTER_OPTION_NO_VALUE = '__none__';
